<form action="" class="grip w-full max-w-full pb-5" [formGroup]="form" (submit)="submit()">
  <div class="flex flex-col pb-2">
    <div class="flex flex-col gap-2 mb-4 mt-4">
      <label for="file_name"> {{ 'Name' | translate }} </label>
      <div class="flex items-center justify-center">
        <input formControlName="file_name" id="file_name" type="text" pInputText class="w-full" />
        <span class="px-3">{{ extension }} </span>
      </div>
      <small class="block leading-6 text-xs">
        {{ 'Enter the name of the File.' | translate }} {{ 'Maximum characters:' | translate }} 50
      </small>
    </div>
    <!-- <div class="flex flex-col gap-2 mb-4 mt-4">
      <label for="comment"> {{ 'Comment' | translate }} </label>
      <input formControlName="comment" id="comment" type="text" pInputText class="w-full" />
      <small class="block leading-6 text-xs">
        {{ '(Optional) Enter the comment of the File.' | translate }}
        {{ 'Maximum characters:' | translate }} 85
      </small>
    </div> -->
  </div>
  <div class="flex flex-col gap-2 mb-4 mt-4">
    <label for="description" class="font-bold"> {{ 'Description' | translate }}</label>
    <textarea
      id="description"
      type="text"
      pTextarea
      rows="2"
      name="description"
      [autoResize]="false"
      [formControlName]="'description'"></textarea>
    <small class="block leading-6 text-xs"
      >{{
        '(Optional) You can create a note for yourself to make it easier to identify.' | translate
      }}{{ 'Maximum characters:' | translate }} 125</small
    >
  </div>

  <div class="flex flex-row-reverse flex-wrap pt-3">
    <div class="flex items-center justify-center">
      <p-button
        icon="pi pi-save"
        iconPos="left"
        type="submit"
        [styleClass]="'w-full'"
        [disabled]="form.invalid"
        label="{{ 'Save' | translate }}"
        [rounded]="true" />
    </div>
  </div>
</form>
